export default __webpack_public_path__ + "static/media/logo.ffda1075.png";